import { render } from "./ClaimCard.vue?vue&type=template&id=1aa9b264&scoped=true"
import script from "./ClaimCard.vue?vue&type=script&lang=js"
export * from "./ClaimCard.vue?vue&type=script&lang=js"

import "./ClaimCard.vue?vue&type=style&index=0&id=1aa9b264&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa9b264"]])

export default __exports__